
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { FlexWrapper } from '../../../styles/WrapperStyles';
import placeholder_image from '../../../assests/placeholder_image.png'
import { PeopleHeaderText } from '../../../styles/TextStyles';
import previousInactive from '../../../assests/arrow_back_grey.png'
import previousActive from '../../../assests/arrow_back.png'
import nextInactive from '../../../assests/arrow_forward_grey.png'
import nextActive from '../../../assests/arrow_forward.png'
import { BaseButton } from '../../../styles/ButtonStyles';
import Loader from '../../Loader';
import { authorizedHttpPost } from '../../../api/httpCalls';
import urls from '../../../api/urls.json'


const ProfileItemWrapper = styled(FlexWrapper)`
  display: flex;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  flex-direction: row;
`;

const ActionButton = styled.button`
  width: 100px;
  height: 66px;
  border-radius: 33px;
  box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
  border: solid 1px #d7d7d7;
  background-color: #ffffff;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #002b37;
  font-family: 'Gilory-Bold';
  ${props =>
        props.selected &&
        css`
      background-color: #002b37;
      color: #ffffff;
    `}
`;

const ImageListSmall = styled.img`
  width: 100%;
  max-width: 150px;
  height: 150px;
  border-radius: 13px;
  object-fit: cover;
  background-color: #d7d7d7;
  ${props =>
        props.rectangle &&
        css`
      height: 225px;
    `}
`;

const TextParent = styled.div`
  width: 730px;
  margin-left: 20px;
  margin-right: 20px;
`;

const ResetWrapper = styled.div`
width:500px
display:flex;
justify-content:space-between
`;

const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;

const AboutInputView = styled.textarea`
    width: 500px;
    height: 100px;
    border-radius: 13px;
    border: solid 1px #d7d7d7;
    font-family: 'Gilory-Semi';
    font-size: 18px;
    font-weight: 600;
    color: #9b9b9b;
    padding: 20px;
    outline: none;
    margin-right: 25%;
`;

const About1 = ({ reviews, page, handleInputOneChange, totalPages, handlePageChangeAbountOne, afterSave, handleReset, currentView }) => {
    const [dismiss, setDismiss] = useState([]);
    const [warn, setWarn] = useState([]);
    const [update, setUpdate] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [decoy, setDecoy] = useState(false);

    useEffect(() => {
        setDismiss([])
        setWarn([])
        setUpdate([])
        fillDefaultAsDismiss()
    }, [reviews])

    const handleInputChange = (e, review_id) => {
        reviews.map(item => {
            if (item.review_id === review_id) {
                item.text = e.target.value
            }
            return item
        });
        setDecoy(!decoy)
    }

    const fillDefaultAsDismiss = () => {
        setDismiss(reviews.map(item => item.review_id))
    }

    useEffect(() => {
        fillDefaultAsDismiss()
    }, []);

    const handleActionItem = (review_id, action) => {
        setDismiss(dismiss.filter(item => item !== review_id))
        setWarn(warn.filter(item => item !== review_id))
        setUpdate(update.filter(item => item.review_id !== review_id))
        if (action === 'dismiss') {
            if (dismiss.includes(review_id)) {
                setDismiss(dismiss.filter(item => item !== review_id))
            } else {
                setDismiss([...dismiss, review_id])
            }
        } else if (action === 'warn') {
            if (warn.includes(review_id)) {
                setWarn(warn.filter(item => item !== review_id))
            } else {
                setWarn([...warn, review_id])
            }
        } else if (action === 'update') {
            if (update.some(item => item.review_id === review_id)) {
                setUpdate(update.filter(item => item.review_id !== review_id))
            } else {
                setUpdate([...update, reviews.find(item => item.review_id === review_id)])
            }
        }
    };

    const handlePageChange = (direction) => {
        if (direction === 'previous' && page > 1) {
            handlePageChangeAbountOne(parseInt(page) - 1)
        } else if (direction === 'next' && page !== totalPages) {
            handlePageChangeAbountOne(parseInt(page) + 1)
        }
    };

    const handleSave = async () => {
        setIsLoading(true)
        let profile_data_update_list = []
        update.forEach(item => {
            profile_data_update_list.push({
                "review_id": item.review_id,
                "text": item.text
            })
        })
        warn.forEach(item => {
            profile_data_update_list.push({
                "review_id": item,
                "send_email": true,
                "text": reviews.find(review => review.review_id === item).text
            })
        })
        let data = {
            "dismissed": dismiss,
            "profile_data_update_list": profile_data_update_list
        }
        let response = await authorizedHttpPost(urls.POST_UPDATE_MULTIPLE, data)
        if (response.status) {
            setDismiss([])
            setWarn([])
            setUpdate([])
            afterSave()
        }
        setIsLoading(false)
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'ArrowLeft') {
                handlePageChange('previous')
            } else if (event.key === 'ArrowRight') {
                handlePageChange('next')
            } else if (event.key === 'Enter') {
                handleSave()
            }
        };
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });


    return (
        <div className='biosOneDiv'>
            {isLoading && <Loader />}
            {reviews.map((review, index) => {
                return (
                    <ProfileItemWrapper key={review.ref}>
                        <ImageListSmall
                            rectangle={false}
                            src={review.avatar}
                            onError={e => {
                                e.target.src = placeholder_image;
                            }}
                        />
                        <TextParent>
                            <ResetWrapper>
                                <HeaderTextView className='floatLeft' selected>{review.name} / </HeaderTextView>
                                <HeaderTextView className='floatLeft' selected>{review.created_at} / </HeaderTextView>
                                <HeaderTextView className='floatLeft' selected>{review.profile_state} / </HeaderTextView>
                                <HeaderTextView className='floatLeft' selected>{review.ref}  </HeaderTextView>
                                <HeaderTextView
                                    className='cursorPointer'
                                    selected
                                    onClick={() => {
                                        handleReset(review.review_id)
                                    }}
                                >
                                    Reset
                                </HeaderTextView>
                            </ResetWrapper>

                            <AboutInputView
                                id={`text_${review.review_id}`}
                                value={review.text}
                                onChange={e => {
                                    handleInputChange(e, review.review_id)
                                }}
                            />
                            <div>
                                {review.keywords.map(text => {
                                    return (
                                        <PeopleHeaderText className='floatLeft' spam highlight>
                                            {' '}
                                            {text} /{' '}
                                        </PeopleHeaderText>
                                    );
                                })}
                            </div>
                        </TextParent>
                        <div className='actionButtonDiv'>
                            <ActionButton
                                className='cursorPointer'
                                selected={dismiss.includes(review.review_id)}
                                onClick={() => handleActionItem(review.review_id, 'dismiss')}
                            >
                                Dismiss
                            </ActionButton>
                            {/* <ActionButton
                                className='cursorPointer'
                                selected={warn.includes(review.review_id)}
                                onClick={() => handleActionItem(review.review_id, 'warn')}
                            >
                                Warn {review.email_sent_count}
                            </ActionButton> */}
                            <ActionButton
                                className='cursorPointer'
                                selected={update.some(item => item.review_id === review.review_id)}
                                onClick={() => handleActionItem(review.review_id, 'update')}
                            >
                                Update
                            </ActionButton>
                        </div>
                    </ProfileItemWrapper>
                )
            })}
            {
                reviews.length > 0 &&
                <div className='pageDirection'>
                    {page === 1 ? <img src={previousInactive} className='arrowIcon' onClick={() => handlePageChange('previous')} /> : <img src={previousActive} onClick={() => handlePageChange('previous')} className='arrowIcon' />}
                    {page === totalPages ? <img src={nextInactive} className='arrowIcon' onClick={() => handlePageChange('next')} /> : <img src={nextActive} onClick={() => handlePageChange('next')} className='arrowIcon' />}
                    <BaseButton onClick={() => handleSave()}>Save</BaseButton>
                </div>
            }
        </div>
    );
};

export default About1;
